import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ThemeToggle } from '@/shared/components/ThemeToggle';
import { useAuth } from '@/app/providers/AuthContext';
import { Button } from '@/ui/Button';

export const DashboardHeader: React.FC = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Logout failed', error);
    }
  };

  return (
    <header className="border-b-2 border-neutral-950 dark:border-neutral-100 sticky top-0 bg-background z-50">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
             <Link to="/dashboard" className="hidden md:flex flex-col justify-center pl-0 h-10 group">
                <span className="text-xl font-mono font-black tracking-tighter text-foreground leading-none group-hover:text-neutral-600 dark:group-hover:text-neutral-400 transition-colors">
                    [CODII.DEV]
                </span>
                 <span className="text-[10px] font-mono text-muted-foreground uppercase tracking-widest leading-none mt-1">
                    Dashboard
                </span>
            </Link>
          </div>
          <div className="flex items-center gap-6 text-sm font-medium font-mono">
            <span className="text-muted-foreground hidden sm:block uppercase">
               User: {user?.user_metadata?.user_name || user?.email}
            </span>
            <div className="w-px h-4 bg-neutral-950 dark:bg-neutral-100 hidden sm:block"></div>
             <Button
                variant="ghost"
                size="sm"
                onClick={handleLogout}
                className="text-sm h-9 px-4 font-bold tracking-wide hover:bg-neutral-100 dark:hover:bg-neutral-900 rounded-none border border-transparent hover:border-neutral-950 dark:hover:border-neutral-100 transition-all text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300"
            >
                [LOGOUT]
            </Button>
            <ThemeToggle />
          </div>
        </div>
      </div>
    </header>
  );
};
